<template>
  <div class="left-side-box">
    <div class="left-side">
      <!-- <div class="ivu-inner" @click="toTop">
            <Icon type="ios-arrow-up" size="24"/>
        </div>
        <div class="ivu-inner" @click="toMiddle">
            <Icon type="ios-arrow-forward" size="24"/>
        </div>
        <div class="ivu-inner" @click="toBottom">
            <Icon type="ios-arrow-down" size="24"/>
        </div> -->
      <Anchor show-ink>
        <AnchorLink v-for="(an,index) in anchor"
                    @click="leftTitleBar(index)"
                    :href="'#' + an.id"
                    :title="an.title" />
      </Anchor>
    </div>
  </div>

</template>
<script>
export default {
  data () {
    return {
      winHeight: 0
    }
  },
  props: {
    anchor: {
      type: Array,
    }
  },
  mounted () {
    // this.winHeight = document.body.clientHeight;
  },
  methods: {
    // toTop(){
    //     window.scrollTo(0,0);
    // },
    // toMiddle(){
    //      window.scrollTo(0,this.winHeight/2);
    // },
    // toBottom(){
    //      window.scrollTo(0,this.winHeight);
    // }
    leftTitleBar (index) {
    }
  }
}
</script>
<style lang="less" scoped>
.left-side-box {
  position: fixed;
  margin: auto;
  z-index: 100;
  width: 980px;
  height: 200px;
  top: 185px;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  .left-side {
    position: absolute;
    left: 988px;
    bottom: 30px;
    top: 0;
    z-index: 9999;
  }
  .ivu-inner {
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease-in-out;
    margin-bottom: 4px;
    i {
      cursor: pointer;
      color: #fff;
      padding: 8px 12px;
    }
  }
}
</style>